import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    setOrder,
    onUpdateColumn
} from '../../../store/precios/reporteseguimientoprecios/actions';
import { sort_by } from '../../../helpers/commons'

import { FieldSet, /*Table*/ } from '@sigeco/tools';
import {
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
    Collapse, IconButton, Paper
} from '@material-ui/core';
import { Icon } from "@material-ui/core";
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flex: '1 1 auto',
        flexDirection: 'column'
    },
    tableWrap: {
        flex: '1 1 auto'
    },
    headerCell: {
        backgroundColor: '#f0f4ff', // fondo tipo blob claro
        boxShadow: 'inset 0 -2px 4px rgba(0, 0, 0, 0.1)', // sombra inferior suave
        borderRadius: '8px 8px 0 0',
        padding: '6px 12px',
        fontWeight: 'bold',
        fontSize: '0.85rem',
        color: '#333',
        textAlign: 'center',
    },
    cellSmall: {
        padding: '2px 8px',
        fontSize: '0.85rem',
    },
    tableContainer: {
        maxHeight: 500,
        overflow: 'auto',
    },
    nestedRow: {
        backgroundColor: '#f9f9f9',
    },
}));

// Agrupar por Distribuidor
const groupByDistribuidor = (arr) => {
    return arr.reduce((acc, item) => {
        if (!acc[item.Distribuidor]) acc[item.Distribuidor] = [];
        acc[item.Distribuidor].push(item);
        return acc;
    }, {});
};
/*
const ReporteSeguimientoPreciosList = ({onMapOpen}) => {
    const classes = useStyles();
    const columns = useSelector(state => state.reporteseguimientoprecios.table.columns);
    const loading = useSelector(state => state.reporteseguimientoprecios.loading);
    const order = useSelector(state => state.reporteseguimientoprecios.table.order);
    const orderBy = useSelector(state => state.reporteseguimientoprecios.table.orderBy);
    const store = useSelector(state => state.reporteseguimientoprecios.store);
    const dispatch = useDispatch();

    console.log(loading)
    const handleRequestSort = (property) => {
        const isAsc = orderBy === property && order === 'asc';
        dispatch(setOrder(isAsc ? 'desc' : 'asc', property));
        let homes = store.data;
        homes.sort(sort_by(property, isAsc, homes[0][property]));
    };

    const handleResizeColumn = (column) => {
        dispatch(onUpdateColumn(column))
    }
    
    return ( 
        
        <div className={classes.root}>
        <FieldSet className={classes.root} iconCls="fas fa-th-list" title="Resultados"   >
            <div className={classes.tableWrap} >
                <Table                      
                    columns={columns}
                    count={store.total}
                    loading={loading}
                    onRowClick={()=> {}}
                    onRowDoubleClick={() => {}}
                    onSort={datakey => handleRequestSort(datakey)}
                    onUpdateColumn={handleResizeColumn}
                    rowCount={store.data.length}
                    rowGetter={index => store.data[index]}
                    selected={store.selected}
                    sortBy={orderBy}
                    sortDirection={order}
                />
            </div>
        </FieldSet>        
       </div>
    )
};
*/

const ReporteSeguimientoPreciosList = () => {
    const classes = useStyles();
    const store = useSelector(state => state.reporteseguimientoprecios.store);
    const columns = useSelector(state => state.reporteseguimientoprecios.table.columns);
    const groupedData = groupByDistribuidor(store.data);
    const [openDistribuidores, setOpenDistribuidores] = useState({});

    const toggleDistribuidor = (nombre) => {
        setOpenDistribuidores(prev => ({
            ...prev,
            [nombre]: !prev[nombre]
        }));
    };

    return (
        <FieldSet className={classes.root} iconCls="fas fa-user-tag" title="Resultados">
            <TableContainer component={Paper} className={classes.tableContainer}>
                <Table size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell className={classes.cellSmall} />
                            <TableCell className={classes.cellSmall}>Distribuidor</TableCell>
                            <TableCell className={classes.cellSmall}>Cantidad Total</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {Object.entries(groupedData).map(([distribuidor, registros]) => (
                            <React.Fragment key={distribuidor}>
                                <TableRow>
                                    <TableCell className={classes.cellSmall}>
                                        <IconButton onClick={() => toggleDistribuidor(distribuidor)}>
                                            {openDistribuidores[distribuidor] ? <Icon className="fas fa-angle-up" /> : <Icon className="fas fa-angle-down" />}
                                        </IconButton>
                                    </TableCell>
                                    <TableCell className={classes.cellSmall}>{distribuidor}</TableCell>
                                    <TableCell className={classes.cellSmall}>{registros.reduce((sum, r) => sum + r.Cantidad, 0)}</TableCell>
                                </TableRow>
                                <TableRow className={classes.nestedRow}>
                                    <TableCell colSpan={3} style={{ padding: 0 }}>
                                        <Collapse in={openDistribuidores[distribuidor]} timeout="auto" unmountOnExit>
                                            <Table size="small">
                                                <TableHead>
                                                    <TableRow>
                                                        {columns.map((col) => (
                                                            <TableCell
                                                                key={col.dataKey}
                                                                style={{ width: col.width }}
                                                                className={`${classes.cellSmall} ${classes.headerCell}`}
                                                            >
                                                                {col.label}
                                                            </TableCell>
                                                        ))}
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {registros.map((r, idx) => (
                                                        <TableRow key={idx}>
                                                            {columns.map((col) => (
                                                                <TableCell
                                                                    key={col.dataKey}
                                                                    className={classes.cellSmall}
                                                                >
                                                                    {r[col.dataKey]}
                                                                </TableCell>
                                                            ))}
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </Collapse>
                                    </TableCell>
                                </TableRow>
                            </React.Fragment>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </FieldSet>
    );
};

export default ReporteSeguimientoPreciosList;